import React from 'react';
import { Stack } from '@mui/material';

import Button from '../../../Buttons/Button/Button';
import VModal from '../../../../Venti-UI-Kit/VModal/VModal';
import VTextInput from '../../../../Venti-UI-Kit/VInputs/VTextInput/VTextInput';
import VSelectInput from '../../../../Venti-UI-Kit/VInputs/VSelectInput/VSelectInput';
import { useEditRebateModal } from './hook';
import {
  VAT_STATUS_OPTIONS,
  REBATE_TYPE_OPTIONS,
  REBATE_TYPE,
} from '../../../../Pages/Backoffice/ProducerPayoutConfigPage/Form/interfaces';

const EditRebateModal = ({ open, settings, updateRebate, handleClose }) => {
  const { formState, handleInputChange, handleRebateTypeChange, handleEdit, handleCancel } =
    useEditRebateModal(updateRebate, handleClose, settings);

  return (
    <VModal
      open={open}
      title="Bonificación Service Charge"
      onClose={handleClose}
      width="100%"
      maxWidth={400}
    >
      <VSelectInput
        title="Tipo de rebate"
        name="rebateType"
        value={formState.rebateType.value}
        onChange={handleRebateTypeChange}
        errorMessage={formState.rebateType.error}
        options={REBATE_TYPE_OPTIONS}
        fullWidth
      />
      {formState.rebateType.value !== REBATE_TYPE.NONE && (
        <VSelectInput
          title="Condición IVA"
          name="vatStatus"
          value={formState.vatStatus.value}
          onChange={handleInputChange}
          errorMessage={formState.vatStatus.error}
          options={VAT_STATUS_OPTIONS}
          fullWidth
        />
      )}
      {formState.rebateType.value === REBATE_TYPE.PERCENTAGE && (
        <VTextInput
          onChange={handleInputChange}
          value={formState.rebatePercentage.value}
          title="Porcentaje"
          name="rebatePercentage"
          type="number"
          errorMessage={formState.rebatePercentage.error}
          endAdornment={<Stack marginRight={2}>%</Stack>}
        />
      )}
      {formState.rebateType.value === REBATE_TYPE.REVENUE_SHARE && (
        <VTextInput
          onChange={handleInputChange}
          value={formState.revenueSharePercentage.value}
          title="Revenue Share (%)"
          name="revenueSharePercentage"
          type="number"
          errorMessage={formState.revenueSharePercentage.error}
          endAdornment={<Stack marginRight={2}>%</Stack>}
        />
      )}
      <Stack gap={2} mt={2}>
        <Button fullWidth title="Cancelar" onClick={handleCancel} variant="outlined" />
        <Button fullWidth title="Editar" onClick={handleEdit} />
      </Stack>
    </VModal>
  );
};

export default EditRebateModal;
